class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      let cartItem = this.closest('.cart-item');
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, '', this.closest('.cart-item'));
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.progressBarShipping();
    this.updateCartNotes();

    // Make Checkout buttons sticky only if it's the Cart page and it's a mobile device
    if (window.location.href.indexOf("/cart") !== -1 && window.innerWidth < 660) {
      this.stickyCheckoutButtons();
    }

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    let updateQuantityNode = event.target.value == 0 ? event.target.closest('.cart-item') : '';
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), updateQuantityNode);
  }


  addDeletedItemMesageCartPage(node) {
    let deletedID = '#' + node.getAttribute('id');
    let newID = parseInt(deletedID.split('-')[1] - 1);
    //If removed element is the last one, in the new appended cart items, the message should appear in the new last item
    if (newID == 0) {
      newID = 1;
    }
    // #CartItem-7
    let idToAppend = `#CartItem-${newID}`
    let productTitle = node.getAttribute('data-product-title');
    let productQuantity = node.getAttribute('data-product-quantity');
    let itemUrl = node.getAttribute('data-item-url');
    // let fullMessage = `<p class="item-removed"> "${themeLocales.removed}" (${productQuantity}) <a href="${itemUrl}" class="item-title">${productTitle}</a> ${themeLocales.from_bag }</p>`;
    let nodeToAppend = document.querySelector(idToAppend);
    if (nodeToAppend) {
      //Condition to check if user removed last product from cart, in this case inject 'Remove message' before last item.
      if (parseInt(deletedID.split('-')[1] - 1) == 0) {

        let fullMessage = `<tr class="cart-item">
        <td>
          <p class="item-removed"> ${themeLocales.removed} (${productQuantity}) <a href="${itemUrl}" class="item-title">${productTitle}</a> ${themeLocales.from_bag}</p>
        </td>
        </tr>`;
        nodeToAppend.insertAdjacentHTML('beforebegin', fullMessage)
      } else {
        let fullMessage = `
        <tr class="cart-item spacer"></tr>
        <tr class="cart-item">
          <td>
            <p class="item-removed"> ${themeLocales.removed} (${productQuantity}) <a href="${itemUrl}" class="item-title">${productTitle}</a> ${themeLocales.from_bag}</p>
          </td>
          </tr>`;
        nodeToAppend.insertAdjacentHTML('afterend', fullMessage)
      }
    }

  }
  addDeletedItemMesage(cartItems, node) {
    let deletedID = '#' + node.getAttribute('id');
    let newID = parseInt(deletedID.split('-')[2] - 1);
    //If removed element is the last one, in the new appended cart items, the message should appear in the new last item
    if (newID == 0) {
      newID = 1;
    }

    let idToAppend = `#CartDrawer-Item-${newID}`
    let productTitle = node.getAttribute('data-product-title');
    let productQuantity = node.getAttribute('data-cart-count');
    let itemUrl = node.getAttribute('data-item-url');
    let fullMessage = `<p class="item-removed"> ${themeLocales.removed} (${productQuantity}) <a href="${itemUrl}" class="item-title">${productTitle}</a> ${themeLocales.from_bag}</p>`;
    let nodeToAppend = document.querySelector(idToAppend);
    if (nodeToAppend) {
      //Condition to check if user removed last product from cart, in this case inject 'Remove message' before last item.
      if (parseInt(deletedID.split('-')[2] - 1) == 0) {
        nodeToAppend.insertAdjacentHTML('beforebegin', fullMessage)
      } else {
        nodeToAppend.insertAdjacentHTML('afterend', fullMessage)
      }
    }

    this.removeMessageFromDOM();

  }
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  outsideClick(event, notelem) {

    let clickedOut = true, i, len = notelem.length;
    for (i = 0; i < len; i++) {
      if (event.target == notelem[i] || notelem[i].contains(event.target)) {
        clickedOut = false;
      }
    }
    if (clickedOut) return true;
    else return false;
  }

  removeMessageFromDOM() {

    let itemToRemove = document.querySelector('.item-removed');
    let drawer_close = document.querySelector('.drawer__close');
    let drawer_overlay = document.querySelector('.drawer__overlay');
    let cartDrawer = document.querySelectorAll('#CartDrawer');


    drawer_close.addEventListener('click', () => {

      if (itemToRemove) {
        itemToRemove.remove();
      }
    })

    drawer_overlay.addEventListener('click', () => {
      if (itemToRemove) {
        itemToRemove.remove()
      }
    })

    let that = this;
    window.addEventListener('click', function (e) {
      if (that.outsideClick(e, cartDrawer)) {
        if (itemToRemove) {
          itemToRemove.remove()
        }
      }
    });

  }


  updateQuantity(line, quantity, name, deletedNode) {
    this.enableLoading(line);

    let body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    let cartBefore = [];
    let cartAfter = [];
    // Cart before change
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        cartBefore = response.items;

        // Cart after change
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            cartAfter = parsedState.items;
            let index = parseInt(line) - 1;
            let cartAfterPrepared = prepareItems(cartAfter);
            localStorage.setItem('cartItems', JSON.stringify(cartAfterPrepared));
            let difference = cartBefore.filter(obj1 => !cartAfter.some(obj2 => obj2.id === obj1.id));

            if (difference.length != 0)
              //send to GTM
              window.handleCart(difference[0], "remove_from_cart", index);
            else {
              const changedObjects = [];

              for (let i = 0; i < cartBefore.length; i++) {
                const obj1 = cartBefore[i];
                const obj2 = cartAfter.find(obj => obj.id === obj1.id);

                if (obj2 && obj1.quantity > obj2.quantity) {
                  obj1.quantity = obj1.quantity - obj2.quantity;
                  changedObjects.push(obj1);
                  //send to GTM
                  window.handleCart(changedObjects[0], "remove_from_cart", index);
                } else if (obj2 && obj1.quantity < obj2.quantity) {
                  obj1.quantity = obj2.quantity - obj1.quantity;
                  changedObjects.push(obj1);
                  window.handleCart(changedObjects[0], "add_to_cart", index);
                }
              }
            }

            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector('drawer-component[data-drawer="cart"]');
            const cartHeader = document.getElementById('main-cart-header');
            const cartFooter = document.getElementById('main-cart-footer');

            if (cartHeader) cartHeader.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

            this.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));

            this.updateLiveRegions(line, parsedState.item_count);
            const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
            }
            this.disableLoading();
            if (deletedNode) {
              this.addDeletedItemMesageCartPage(deletedNode);
            }
            if (deletedNode) {
              this.addDeletedItemMesage(parsedState, deletedNode);
            }
          }).then(() => {
            this.progressBarShipping();
            window.createKlevuSliderMiniCart();
          }).catch(() => {
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            //errors.textContent = window.cartStrings.error;
            this.disableLoading();
          });

      })
      .catch((e) => {
        console.error(e);
      })
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
    console.log('cart-updated')

     var getCartTotalElement = document.querySelector('.cart-items-total');
    if(getCartTotalElement){
      var getCartTotal = getCartTotalElement.getAttribute('data-cart-total');
      console.log(getCartTotal);
    }
    var freeGiftProducts = document.querySelectorAll('.free-gift-product');
    if(freeGiftProducts){
      freeGiftProducts.forEach(freeGiftProduct => {
        var freeLimitValue = freeGiftProduct.getAttribute('data-free-limit');
        var freeItemTitle = freeGiftProduct.getAttribute('data-free-added');
        var freePercent = freeGiftProduct.getAttribute('data-free-percent');
        var freePercentage = (getCartTotal * 100) / freeLimitValue;
        if(freeLimitValue > getCartTotal){}
          var remainingToFree = freeLimitValue - getCartTotal;

        console.log(remainingToFree,'remainingToFree');
        if(freeLimitValue > getCartTotal){
          console.log('freeLimitValue > getCartTotal');
          if(remainingToFree > 0){
            let formattedRemainingToFree = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(remainingToFree);

            let formatter = new Intl.NumberFormat('id-ID', { 
                style: 'currency', 
                currency: 'IDR'
            });

            let formattedPrice = formatter.format(remainingToFree);
            if (formattedPrice.endsWith(',00')) {
                formattedPrice = formattedPrice.slice(0, -3);
            }
            
            console.log(formattedPrice,'formatted');

            
            freeGiftProduct.querySelector('circle').setAttribute('style',"stroke-dasharray: 133.518; stroke-dashoffset:  calc(133.518px - (133.518px * "+freePercentage+") / 100);");
            freeGiftProduct.querySelector('.cart-add-form').classList.remove('hidden');
            freeGiftProduct.querySelector('.cart-change-form').classList.add('hidden');
            console.log(freeGiftProduct.querySelector('.redeem-btn'));
            freeGiftProduct.querySelector('.cart-add-form').querySelector('.redeem-btn').textContent = 'add ' +formattedPrice+ ' more';
            freeGiftProduct.querySelector('.cart-add-form').querySelector('.redeem-btn').setAttribute('disabled','true');
            
            console.log('remainingToFree',formattedRemainingToFree);
            freeGiftProduct.querySelector('.gwp-subtitle span').innerHTML = `You're only <span data-currency="{{ cart.currency.symbol }}" class="away-from">${formattedPrice}</span> away from this reward!`;
          }
          
        }
        else{
          console.log('freeLimitValue < getCartTotal')
        }
          if(remainingToFree > 0){
            var remainingTargetElements = freeGiftProduct.querySelectorAll('.away-from');
            if(remainingTargetElements){
              let formattedRemainingToFree = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(remainingToFree);

              let formatter = new Intl.NumberFormat('id-ID', { 
                  style: 'currency', 
                  currency: 'IDR'
              });
  
              let formattedPrice = formatter.format(remainingToFree);
              if (formattedPrice.endsWith(',00')) {
                  formattedPrice = formattedPrice.slice(0, -3);
              }
              
              console.log(formattedPrice,'formatted');
              
              remainingTargetElements.forEach(remainingTargetElement => {
                var remainingTargetElementCurrency = remainingTargetElement.getAttribute('data-currency');
                remainingTargetElement.innerHTML = remainingTargetElementCurrency + ' ' + remainingToFree;
                freeGiftProduct.querySelector('circle').setAttribute('style',"stroke-dasharray: 133.518; stroke-dashoffset:  calc(133.518px - (133.518px * "+freePercentage+") / 100);")
            
                freeGiftProduct.querySelector('.gwp-subtitle span').innerHTML = `You're only <span data-currency="{{ cart.currency.symbol }}" class="away-from">${formattedPrice}</span> away from this reward!`;
                
                freeGiftProduct.querySelector('.cart-add-form').classList.remove('hidden');
                freeGiftProduct.querySelector('.cart-change-form').classList.add('hidden');
                console.log('remainingToFree: ',remainingToFree,' getCartTotal: ',getCartTotal);
              })
            } 
          }else{
            var variantFound = false;
            function checkVariantInCart(dataIdValue) {
  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "/cart.js", true);
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var data = JSON.parse(xhr.responseText);
          if (data.items && data.items.length > 0) {
            var variantFound = false;
            for (var i = 0; i < data.items.length; i++) {
              if (data.items[i].variant_id == dataIdValue) {
                variantFound = true;
                break;
              }
            }
            resolve(variantFound);
          } else {
            resolve(false); // Cart is empty
          }
        } else {
          reject(xhr.statusText); // Error occurred
        }
      }
    };
    xhr.send();
  });
}

let dataIdValue = freeGiftProduct.querySelector('.redeem-btn').getAttribute('data-id');
checkVariantInCart(dataIdValue)
  .then(function(variantFound) {
    if (variantFound) {
      console.log("Variant", dataIdValue, " in the cart.");
       freeGiftProduct.querySelector('.gwp-subtitle span').innerHTML = `Your FREE <span class="capitalize">${freeItemTitle}</span> was added to your bag`;
            freeGiftProduct.querySelector('.cart-add-form').classList.add('hidden');
            freeGiftProduct.querySelector('.cart-change-form').classList.remove('hidden');
            freeGiftProduct.querySelector('.redeem-btn').textContent = 'remove';
            freeGiftProduct.querySelector('.redeem-btn').removeAttribute('disabled');
            freeGiftProduct.querySelector('circle').setAttribute('style',"stroke-dasharray: 133.518; stroke-dashoffset:  calc(133.518px - (133.518px * 100) / 100);");
    } else {
      console.log("Variant", dataIdValue, " not in the cart.");
      let btn_add_selector = '.form_'+dataIdValue+' .redeem-btn';
      freeGiftProduct.querySelector('.gwp-subtitle span').innerHTML = `Sweet! Your order qualifies for this reward — redeem now!`;
            freeGiftProduct.querySelector('.cart-add-form').classList.remove('hidden');
            freeGiftProduct.querySelector('.cart-change-form').classList.add('hidden');
            document.querySelector(btn_add_selector).textContent = 'get this free';
            document.querySelector(btn_add_selector).removeAttribute('disabled');
            document.querySelector(btn_add_selector).classList.remove('remove-redeem-btn');
            document.querySelector(btn_add_selector).classList.add('add-redeem-btn');
            freeGiftProduct.querySelector('circle').setAttribute('style',"stroke-dasharray: 133.518; stroke-dashoffset:  calc(133.518px - (133.518px * 100) / 100);");
    }
  })
  .catch(function(error) {
    console.error("Error occurred:", error);
  });


          }
        
        
      })
    }
    
  }

  progressBarShipping() {
    var country = Shopify.country;
    
    var shipping_threshold = country + 'FreeShippingThreshold';
    var freeThreshold = Math.round (100 * parseFloat(theme.settings[shipping_threshold]));
    // console.log('country: '+country+' FreeShippingThreshold: '+freeThreshold);
    var total_threshold = country + 'MaxItemThreshold';
    var totalThreshold = Math.round (100 * parseInt(theme.settings[total_threshold]));
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        var carTotalPrice = data.total_price;
        var ProgressPercentage = Math.floor((100 * carTotalPrice) / freeThreshold);
        var ProgressBar;
        var ProgressBarMessage;
        var ProgressBarHtml = '';
        var ProgressBarMessageHtml = '';

        if (this.tagName == 'CART-DRAWER-ITEMS') {
          ProgressBar = this.querySelector('.progress_bar_shipping');
          ProgressBarMessage = this.querySelector('.progress_bar_shipping_message');
        }
        else if (this.tagName == 'CART-ITEMS') {
          ProgressBar = this.parentNode.parentNode.querySelector('.progress_bar_shipping_mb');
          ProgressBarMessage = this.parentNode.parentNode.querySelector('.progress_bar_shipping_message');
        }
        
        let checkoutButton = document.querySelectorAll('.cart__checkout-button');
        if(this.currentItemCount > parseInt(theme.settings['cart_total_limit'])) {          
          ProgressBarHtml = '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width:100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div></div><span class="percent">100%</span>';
          ProgressBarMessageHtml = theme.strings.limitItemMaximum;
          ProgressBar.classList.add('success');
          ProgressBar.classList.add('error');  
          checkoutButton.forEach(el => el.disabled = true);
        } else if(carTotalPrice > totalThreshold) {     
          ProgressBarHtml = '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width:100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div></div><span class="percent">100%</span>';
          ProgressBarMessageHtml = theme.strings.limitTotalMaximum;
          ProgressBar.classList.add('success');
          ProgressBar.classList.add('error');  
          checkoutButton.forEach(el => el.disabled = true);
        } else {
          ProgressBar.classList.remove('error');
          checkoutButton.forEach(el => el.disabled = false);
          if (carTotalPrice < freeThreshold) {
            ProgressBarHtml = '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width:'
              + ProgressPercentage + '%" aria-valuenow="'
              + ProgressPercentage + '" aria-valuemin="0" aria-valuemax="100">'
              + ProgressPercentage + '%</div></div>';
            var freeShippingDifference = freeThreshold - carTotalPrice;
            var shopifyCurrency = ProgressBarMessage.dataset.symbol;
            ProgressBarMessageHtml = theme.strings.shippingMessage.replace("[price]", `${shopifyCurrency}<span data-js-price="${freeShippingDifference}"> ${shopifyCurrency} ${freeShippingDifference} </span>`);
            ProgressBar.classList.remove('success');
            // console.log('Shopify.currency.active',Shopify.currency.active,ProgressBarMessageHtml)
          }
          else {
            ProgressBarHtml = '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width:100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div></div><span class="percent">100%</span>';
            ProgressBarMessageHtml = theme.strings.freeShipping;
            ProgressBar.classList.add('success');
          }
        }

        ProgressBar.innerHTML = ProgressBarHtml;
        ProgressBarMessage.innerHTML = ProgressBarMessageHtml;
      })
      .then(function () {
        if (window.formatPrices) {
          window.formatPrices("[data-js-price]");
        }
      })
  }

  // Function that returns the user IP address
  async getUserIP() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      const ipAddress = data.ip;

      return ipAddress;
    }
    catch (error) {
      console.error('Error fetching IP address:', error);
      return null;
    }
  }

  // Returns user device name (iphone/ipad/windows/android etc...)
  getDeviceName() {
    var device = 'Desktop';

    if (navigator.userAgentData && navigator.userAgentData.mobile) {
      device = navigator.userAgentData.platform;
    } else if (/iPad/i.test(navigator.userAgent)) {
      device = 'iPad';
    } else if (/iPhone/i.test(navigator.userAgent)) {
      device = 'iPhone';
    } else if (/Android/i.test(navigator.userAgent)) {
      device = 'Android';
    } else if (/Windows Phone/i.test(navigator.userAgent)) {
      device = 'Windows Phone';
    } else if (/Tablet/i.test(navigator.userAgent)) {
      device = 'Tablet';
    }

    if (/Win/i.test(navigator.userAgent)) {
      device = 'Windows';
    } else if (/Mac/i.test(navigator.userAgent)) {
      device = 'Mac';
    } else if (/Linux/i.test(navigator.userAgent)) {
      device = 'Linux';
    }

    return device;
  }

  // Function to return browser details (name & version)
  getBrowserInfo() {
    var browserName = '';
    var browserVersion = '';

    if (/OPR/i.test(navigator.userAgent)) {
      browserName = 'Opera';
      browserVersion = navigator.userAgent.match(/OPR\/([\d.]+)/)[1];
    } else if (/Edg/i.test(navigator.userAgent)) {
      browserName = 'Microsoft Edge';
      browserVersion = navigator.userAgent.match(/Edg(?:e|A|iOS|W|\?)?\/([\d.]+)/i)[1];
    } else if (/Chrome/i.test(navigator.userAgent)) {
      browserName = 'Google Chrome';
      browserVersion = navigator.userAgent.match(/(?:Chrome|CriOS)\/([\d.]+)/)[1];
    } else if (/Safari/i.test(navigator.userAgent)) {
      browserName = 'Safari';
      if(navigator.userAgent.indexOf("Version") !== -1) {
        browserVersion = navigator.userAgent.match(/Version\/([\d.]+)/)[1];   
       } else if(navigator.userAgent.indexOf("CriOS") !== -1) {
        browserVersion = navigator.userAgent.match(/CriOS\/([\d.]+)/)[1]; 
       } 
    } else if (/Firefox/i.test(navigator.userAgent)) {
      browserName = 'Mozilla Firefox';
      browserVersion = navigator.userAgent.match(/(?:Firefox|FxiOS)\/([\d.]+)/)[1];
    } else {
      browserName = 'Unknown Browser';
      browserVersion = 'N/A';
    }

    return {
      browserName: browserName,
      browserVersion: browserVersion
    }
  }

  // Function to set the order notes value for device name
  setDeviceName() {
    const deviceInputs = document.querySelectorAll('.device');
    const deviceName = this.getDeviceName();

    // Update device name
    if (deviceInputs) {
      deviceInputs.forEach((deviceInput) => {
        deviceInput.value = deviceName;
      });
    }
  }

  // Function to set the order notes value for browser name & version
  setBrowserInfo() {
    // getting order notes node selectors
    const browserInputs = document.querySelectorAll('.browser-name');
    const browserVersionInputs = document.querySelectorAll('.browser-version');

    // getting user browser data
    const { browserName } = this.getBrowserInfo();
    const { browserVersion } = this.getBrowserInfo();

    // Update browser name
    if (browserInputs) {
      browserInputs.forEach((browserInput) => {
        browserInput.value = browserName;
      });
    }

    // Update browser version
    if (browserVersionInputs) {
      browserVersionInputs.forEach((browserVersionInput) => {
        browserVersionInput.value = browserVersion;
      });
    }
  }

  // Function to set the order notes value for IP address
  setUserIp() {
    const ipInputs = document.querySelectorAll('.public-ip-address');
    const getIp = this.getUserIP();

    getIp.then((ipAddress) => {
      // update IP node selectors
      if (ipInputs) {
        ipInputs.forEach((ipInput) => {
          ipInput.value = ipAddress;
        });
      }
    });
  }

  // Function that updates the order notes values
  updateCartNotes() {
    this.setBrowserInfo();
    this.setDeviceName();
    this.setUserIp();
  }

  stickyCheckoutButtons() {
    let selectors = {
      stickyElement: ".make-sticky",
      dynamicExpressBtns: ".cart__dynamic",
      cartBtns: ".cart__footer .cart__ctas",
      stickyCheckoutBtn: ".cart__dynamic-checkout_button",
      GooglePayBtn: "[data-testid='GooglePay-button']",
      stickyBottomBar: ".bottom-announcement-bar"
    };

    let nodeSelector = {
      stickyElement: document.querySelector(selectors.stickyElement),
      dynamicExpressBtns: document.querySelector(selectors.dynamicExpressBtns),
      cartBtns: document.querySelector(selectors.cartBtns),
      stickyCheckoutBtn: document.querySelector(selectors.stickyCheckoutBtn),
      stickyBottomBar: document.querySelector(selectors.stickyBottomBar)
    }

    // Hidding Google Pay button on iPhone
    function hideButtonOnDevice(selector, device) {
      if (selector && device && navigator.platform === device) {
        selector.parentElement.classList.add("device-hidden");
      }
    }

    // Show the sticky checkout buttons div
    function showStickyExpressButtons() {
      nodeSelector.dynamicExpressBtns.classList.add("isSticky");
      nodeSelector.stickyCheckoutBtn.classList.remove("hidden");
      nodeSelector.dynamicExpressBtns.querySelector(".cart__dynamic-sticky-buttons").style.transform = "translateY(0)";
    }

    // Hide the sticky checkout buttons div
    function hideStickyExpressButtons() {
      nodeSelector.dynamicExpressBtns.classList.remove("isSticky");
      nodeSelector.stickyCheckoutBtn.classList.add("hidden");
      nodeSelector.dynamicExpressBtns.querySelector(".cart__dynamic-sticky-buttons").removeAttribute("style");
    }

    // Main logic for making the checkout buttons sticky
    function makeExpressButtonsSticky() {
      var checkoutBtnsOffset = nodeSelector.cartBtns.offsetTop - window.innerHeight;
      var expressBtnsOffset = nodeSelector.dynamicExpressBtns.offsetTop;
      var expressBtnsHeight = nodeSelector.dynamicExpressBtns.offsetHeight;

      // if scrolling before or after payment buttons, show sticky buttons
      if (window.scrollY < checkoutBtnsOffset || window.scrollY > (expressBtnsOffset + expressBtnsHeight - 50)) {
        showStickyExpressButtons();
      }
      // if intersecting the payment buttons, hide sticky buttons
      else if (window.scrollY > checkoutBtnsOffset && window.scrollY < (expressBtnsOffset + expressBtnsHeight)) {
        hideStickyExpressButtons();
      }
    }

    // Reposition sticky checkout buttons over the bottom sticky bar if it exists
    function repositionOverAnnouncementBar() {
      if(nodeSelector.stickyBottomBar && !nodeSelector.stickyBottomBar.classList.contains("hidden")) {
        nodeSelector.stickyElement.classList.add("reposition");
      } else {
        nodeSelector.stickyElement.classList.remove("reposition");
      }
    }

    // Creates an observer to wait for Express Checkout buttons to appear on screen
    function waitForExpressCheckoutBtns(selector) {
      const observer = new MutationObserver((mutations) => {
        makeExpressButtonsSticky();
        repositionOverAnnouncementBar();

        window.addEventListener("scroll", () => {
          makeExpressButtonsSticky();
          repositionOverAnnouncementBar();
          hideButtonOnDevice(document.querySelector(selectors.GooglePayBtn), "iPhone");
        });
      });

      observer.observe(selector, { childList: true, subtree: true });
    }

    function init() {
      if (nodeSelector.stickyElement) {
        waitForExpressCheckoutBtns(nodeSelector.stickyElement);
      }
    }

    // Initialise function
    init();
  }
}

customElements.define('cart-items', CartItems);

var cartNoteBox = document.querySelector('.cart__note .text-area');
function giftMessage() {
  var cartNoteBoxLength = cartNoteBox.value.length;
  var giftSuccess = document.querySelector('.gift-change-success');
    giftSuccess.style.opacity = 1;
    setTimeout(function() {
      giftSuccess.style.opacity = 0;
    }, 600);
}

var currentMessageLength = document.querySelector('.current-gm-length');
console.log(currentMessageLength,'currentMessageLength');
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
        
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  var cartNotes = document.querySelectorAll('.cart__note textarea');
  if(cartNotes){
    cartNotes.forEach(cartNoteText => {
      if(currentMessageLength){
        currentMessageLength.innerHTML = cartNoteText.value.length
      }
      setTimeout(function(){
        if(cartNoteText.value.length > 200){
        cartNoteText.style.borderColor = 'red';
        if(document.querySelector('.gift-input-info')){
          document.querySelector('.gift-input-info').style.color = 'red';  
        }else{
          cartNoteText.style.borderColor = '#636363';
         if(document.querySelector('.gift-input-info')){
           document.querySelector('.gift-input-info').style.color = '#636363';  
         }
        }
      }
      },2000)
      


      cartNoteText.addEventListener('input', debounce((event) => {
      console.log('check textarea',cartNoteText);
      var cartNoteMaxLength = cartNoteText.getAttribute('maxlength');
      if(currentMessageLength){
        currentMessageLength.innerHTML = cartNoteText.value.length;
        if(cartNoteText.value.length > 200){
          cartNoteText.style.borderColor = 'red';
          if(document.querySelector('.gift-input-info')){
             document.querySelector('.gift-input-info').style.color = 'red';  
          }
        }else{
          cartNoteText.style.borderColor = '#636363';
          if(document.querySelector('.gift-input-info')){
           document.querySelector('.gift-input-info').style.color = '#636363';  
          }
        }
      }
    }))
      
    })
  }
})




